/**
 * CRM / AndromedApp Service
 * Consume los endpoints del modulo AndromedApp (schema `crm` en Supabase,
 * replicado desde CRM_FARMACIA). Backend: routes/crm.py
 *
 * Todos los endpoints analiticos aceptan un rango de fecha opcional
 * { from, to } en formato YYYY-MM-DD.
 */

const API_URL = process.env.REACT_APP_STRANDS_API_URL || 'http://localhost:5001';

async function getJson(path) {
  const res = await fetch(`${API_URL}${path}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
  if (!res.ok) {
    let msg = `Error ${res.status}`;
    try {
      const e = await res.json();
      msg = e.error || msg;
    } catch (_) { /* respuesta sin JSON */ }
    throw new Error(msg);
  }
  return res.json();
}

/** Construye ?from=...&to=... a partir de un rango (ignora valores vacios). */
function qs(range = {}, extra = {}) {
  const p = new URLSearchParams();
  if (range.from) p.set('from', range.from);
  if (range.to) p.set('to', range.to);
  Object.entries(extra).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') p.set(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : '';
}

// ── Global ───────────────────────────────────────────────────────────────────
export const getCrmBounds = () => getJson('/api/crm/bounds');

// ── Ventas Totales ────────────────────────────────────────────────────────────
export const getCrmOverview = (range) => getJson(`/api/crm/overview${qs(range)}`);
export const getCrmSalesTimeseries = (range) => getJson(`/api/crm/sales-timeseries${qs(range)}`);
export const getCrmCuota = (range) => getJson(`/api/crm/cuota${qs(range)}`);

// ── PDV ───────────────────────────────────────────────────────────────────────
export const getCrmPdv = (range, limit = 12) => getJson(`/api/crm/pdv${qs(range, { limit })}`);

// ── Cadenas / Geolocalizacion ─────────────────────────────────────────────────
export const getCrmGeo = (range) => getJson(`/api/crm/geo${qs(range)}`);

// ── Consejera ─────────────────────────────────────────────────────────────────
export const getCrmConsejeras = (range, limit = 20) => getJson(`/api/crm/consejeras${qs(range, { limit })}`);

// ── Producto ──────────────────────────────────────────────────────────────────
export const getCrmProductos = (range, limit = 15) => getJson(`/api/crm/productos${qs(range, { limit })}`);

// ── Explorador legacy ─────────────────────────────────────────────────────────
export const getCrmTables = () => getJson('/api/crm/tables');
export const getCrmTablePreview = (name, limit = 50) =>
  getJson(`/api/crm/table/${encodeURIComponent(name)}?limit=${limit}`);
